import { FC } from "react";
//#region types
import { CurrencyCode } from "models/enums/currency";
import { CurrencyInputProps } from "models/propTypes/wintFormPropsTypes";
import { BenefitValueProps } from "models/propTypes/benefitsPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { CurrencyInput, VerticalFormField } from "components/common/wintForms";
import BenefitValueDescription from "./benefitValueDescription";
import { hasBenefitValue, isDeductionBenefitType } from "../forms/useBenefitTypesHelper";
//#endregion

const BenefitValue: FC<BenefitValueProps> = (props) => {
  const { connect, benefitTypeId, isCarBenefit, isCalculating } = props;

  return (
    <VerticalFormField<CurrencyInputProps>
      Component={CurrencyInput}
      {...connect("benefitValue")}
      label={
        isDeductionBenefitType(benefitTypeId)
          ? TranslationKeys.Benefit.DeductionAmountLabel
          : TranslationKeys.Benefit.BenefitValueLabel
      }
      decimalPoints={2}
      currency={CurrencyCode.SEK}
      descriptionText={hasBenefitValue(benefitTypeId) ? <BenefitValueDescription /> : undefined}
      showMainLabel
      icon={isCarBenefit ? IconDefinitionConstants.WBolt : undefined}
      endIcon={isCarBenefit ? true : undefined}
      disabled={isCarBenefit}
      isLoading={isCalculating}
    />
  );
};

export default BenefitValue;
